import React, { FC, useCallback } from 'react'
import AddIcon from 'transfix-icons/build/AddIcon'
import { Button } from 'transfix-ui/components/Button'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'
import SavedLaneFormModal from './SavedLaneFormModal'
import { SavedLanesDeleteModal } from './SavedLanesDeleteModal'
import { SavedLanesTable } from './SavedLanesTable'
import { useSavedLaneModals } from './hooks/useSavedLaneModals'
import { useSavedLanes } from './hooks/useSavedLanes'

export interface ISavedLanesProps {
  carrierApplicationId: string
}

export const SavedLanes: FC<ISavedLanesProps> = ({ carrierApplicationId }) => {
  const { refetch, savedLanes } = useSavedLanes({ carrierApplicationId })
  const {
    closeModals,
    isAddEditModalOpen,
    isDeleteModalOpen,
    openAddModal,
    openDeleteModal,
    openEditModal,
    selectedSavedLane,
  } = useSavedLaneModals()
  const { id: selectedSavedLaneId } = selectedSavedLane || {}

  const successHandler = useCallback(() => {
    closeModals()
    refetch()
  }, [refetch, closeModals])

  return (
    <Card dataTest='saved-lanes'>
      {/* Heading */}
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='h3'>Saved Lanes</Typography>
        <Button startIcon={<AddIcon />} onClick={openAddModal} data-test='add-saved-lane-button'>
          Save New Lane
        </Button>
      </Box>
      {/* Preamble */}
      <Box mt={2} mb={4}>
        Save lanes and configure alerting so that carrier users are notified of lanes matching their
        preferences.
      </Box>
      {/* Table Body */}
      <SavedLanesTable savedLanes={savedLanes} onDelete={openDeleteModal} onEdit={openEditModal} />
      {/* Add/Edit Modal */}
      {isAddEditModalOpen && (
        <SavedLaneFormModal
          carrierApplicationId={carrierApplicationId}
          savedLane={selectedSavedLane}
          onClose={closeModals}
          onSuccess={successHandler}
        />
      )}
      {/* Delete Modal */}
      {isDeleteModalOpen && selectedSavedLaneId && (
        <SavedLanesDeleteModal
          carrierApplicationId={carrierApplicationId}
          savedLaneId={selectedSavedLaneId}
          onClose={closeModals}
          onSuccess={successHandler}
        />
      )}
    </Card>
  )
}
